// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__25Q2s","checkboxCol":"Table_checkboxCol__3OwUz","emailCol":"Table_emailCol__TN3kk","actionCol":"Table_actionCol__1wpZw"};